export interface FrameModel {
    childFrameId: string;
    name: string;
    description: string;
    sampleImageUrl: string;
    frameDetailSampleImageUrl: string;
    imagesCount: number;
    layout: string;
    price: number;
    aspectRatio: AspectRatio;
    isCollabFrame: boolean;
}

export enum AspectRatio {
    ONE_TO_ONE = "1:1",
    FOUR_TO_THREE = "4:3",
    THREE_TO_FOUR = "3:4",
    FOUR_TO_FIVE = "4:5",
    FIVE_TO_FOUR = "5:4",
}